<template>
    <component :is="themeName" :id="themeName"/>
</template>

<script>

import Vue from 'vue'
import camelCase from 'lodash/camelCase'
import upperFirst from 'lodash/upperFirst'



// Load theme folder
const requireComponent = require.context('./', true, /\.layout\.vue$/i);
requireComponent.keys().forEach(fileName => {
    // console.log(fileName)

    const componentConfig = requireComponent(fileName)
    const componentName = upperFirst(
        camelCase(
            fileName.split('/')[1]
        )
    )

    Vue.component(
        componentName,
        // Look for the component options on `.default`, which will
        // exist if the component was exported with `export default`,
        // otherwise fall back to module's root.
        componentConfig.default || componentConfig
    )
})


export default {
    
    components: {
    },
    computed: {
        themeSetting () {
            return this.$store.getters['getThemeSetting']
        },
        themeName () {
            // let theme = this.themeSetting
            return `${this.themeSetting}-layout` 
        }
    },
    data () {
        return {
        }
    },
    watch: {
    },
    methods: {
    },
    mounted() {
        setTimeout(async () => {
            
        }, 500)
    },
    created() {
    },
}
</script>
